import {AppDialog} from 'components/dialogs';
import {AppStatusSelect} from 'components/form';
import {useMoveItemToStatus} from 'hooks';
import {useAlert} from 'hooks/useAlert';
import React, {useEffect} from 'react';
import {useForm} from 'react-hook-form';
import {useParams} from 'react-router-dom';
import {BoardTableViewActionsCommonProps} from '../TableViewMultiRowSelectedActions';
import ActionsTitle from './ActionsTitle';
interface BoardViewUpdateStatusDialogProps extends BoardTableViewActionsCommonProps {}
export const BoardViewUpdateStatusDialog: React.FC<BoardViewUpdateStatusDialogProps> = ({
    selectedRows,
    onClose,
    open,
}) => {
    const {control, handleSubmit} = useForm<{itemStatusId: string}>({defaultValues: {itemStatusId: ''}});
    const {boardId} = useParams();
    const {moveItemToStatus, moveItemToStatusLoading, moveItemToStatusResponse} = useMoveItemToStatus(true);
    const {invokeSuccessMessage} = useAlert();
    useEffect(() => {
        if (moveItemToStatusResponse && !moveItemToStatusLoading) {
            invokeSuccessMessage(`The status successfully updated.`);
            onClose(true);
        }
    }, [moveItemToStatusLoading, moveItemToStatusResponse]);

    const onSubmitHandler = (data: {itemStatusId: string}) => {
        if (selectedRows.length > 0 && data.itemStatusId) {
            moveItemToStatus({
                variables: {
                    input: {
                        itemStatusId: data.itemStatusId,
                        itemIds: selectedRows.map(item => item.id),
                    },
                },
            });
        }
    };

    return (
        <>
            <AppDialog
                isForm={true}
                onFormSubmit={handleSubmit(onSubmitHandler)}
                open={open}
                title={<ActionsTitle title="Update Status" selectedRows={selectedRows} />}
                fullWidth
                maxWidth="sm"
                footerProps={{
                    onCancelClick: () => onClose(false),
                    submitButtonProps: {
                        type: 'submit',
                        isLoading: moveItemToStatusLoading,
                        disabled: moveItemToStatusLoading,
                    },
                }}
                onCloseDialog={() => onClose(false)}
                children={
                    <div>
                        <AppStatusSelect
                            fullWidth
                            disableClearable={true}
                            shouldReturnValueOnly={true}
                            required={true}
                            label="Select Status"
                            boardSlug={boardId ?? ''}
                            name="itemStatusId"
                            control={control}
                        />
                    </div>
                }
            />
        </>
    );
};

export default BoardViewUpdateStatusDialog;
